import { Big } from 'big.js'
import type { NumberFormatOptions } from '@base/utils'
import { numberFormat } from '@base/utils'
import type { TokenSymbols } from './useTokens'
export interface TokenNumberFormatOptions extends NumberFormatOptions {
  /** Depending on the token and twoDecimalTokens, confirm whether to limit decimal places */
  token: TokenSymbols | 'SNIPER' | 'BULLET'
}
const twoDecimalTokens = ['USDC', 'uHODL', 'DOB']
/**
 * @description For the quantity of specific tokens, up to 2 decimal places, other tokens are formatted according to the default of numberFormat.
 * @export
 * @param {(number | string | Big)} num
 * @param {TokenNumberFormatOptions} [options={}]
 */
export function useTokenNumberFormat(
  num: number | string | Big,
  options: TokenNumberFormatOptions,
) {
  const { token, ...numberFormatOption } = options
  let _numberFormatOption = numberFormatOption

  const dp = numberFormatOption.dp
  let minNumber = Big(1).div(10 ** (dp || 8))
  let isMinNumber = Big(num || 0).lt(minNumber) && !Big(num || 0).eq(0)

  if (twoDecimalTokens.includes(token)) {
    minNumber = Big(1).div(10 ** (dp || 2))
    isMinNumber = Big(num || 0).lt(minNumber) && !Big(num || 0).eq(0)

    _numberFormatOption = {
      ...numberFormatOption,
      dp: 2,
    }
  }

  return isMinNumber
    ? '<' + minNumber.toFixed()
    : numberFormat(num, 'en-US', _numberFormatOption)
}
